import { render, staticRenderFns } from "./ClinicalTrials.vue?vue&type=template&id=464406b4"
import script from "./ClinicalTrials.vue?vue&type=script&lang=js"
export * from "./ClinicalTrials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports